import React from 'react'
import { CircularProgress, Dialog, DialogContent, Typography } from '@material-ui/core'
import { Translate } from 'src/translation'

type Props = {
  open: boolean
  progress: number | null
  translate: Translate
  tubeColor: string
}

const UploadProgressDialog = ({ open, progress, translate, tubeColor }: Props) => {
  const isUploading = progress != null && progress !== 100

  return (
    <Dialog open={open}>
      <DialogContent style={{ width: '400px', textAlign: 'center', padding: '32px 24px' }}>
        <div style={{ position: 'relative', display: 'inline-flex', marginBottom: '24px' }}>
          <CircularProgress
            variant={isUploading ? 'determinate' : 'indeterminate'}
            value={progress || 0}
            size={80}
            thickness={4}
            style={{ color: tubeColor }}
          />
          {isUploading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {`${progress.toFixed(0)}%`}
              </Typography>
            </div>
          )}
        </div>
        <Typography variant="title" style={{ marginBottom: '8px' }}>
          {isUploading ? translate('uploading') : translate('hold-on-magic-happens')}
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default UploadProgressDialog
